import React from "react";
import Str from "shared/components/Str";

import "./Blog.scss";

const Blog = () => {
	return (
		<a
			className="discovery-promo-blog"
			href="http://blog.okcupid.com"
			target="_blank"
			rel="noopener noreferrer"
		>
			<span className="discovery-promo-blog-text">
				<Str>Visit the OkCupid blog</Str>
			</span>
		</a>
	);
};

export default Blog;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/interruptions/Blog.jsx